/**
# ===========================================
# APPLICATION CONFIGURATION
# ===========================================
*/
export const NEXT_PUBLIC_APP_URL =
  process.env.NEXT_PUBLIC_APP_URL || 'http://localhost:3000';
export const NODE_ENV = process.env.NODE_ENV || 'development';

/**
# ===========================================
# DATABASE CONFIGURATION
# ===========================================
*/
export const DATABASE_URL = process.env.DATABASE_URL;
export const DIRECT_URL = process.env.DIRECT_URL;

/**
# ===========================================
# NEXTAUTH CONFIGURATION
# ===========================================
*/
export const NEXTAUTH_SECRET = process.env.NEXTAUTH_SECRET;
export const NEXTAUTH_URL = process.env.NEXTAUTH_URL || 'http://localhost:3000';
export const GOOGLE_CLIENT_ID = process.env.GOOGLE_CLIENT_ID;
export const GOOGLE_CLIENT_SECRET = process.env.GOOGLE_CLIENT_SECRET;

/**
# ===========================================
# CLOUDINARY CONFIGURATION
# ===========================================
*/
export const CLOUDINARY_CLOUD_NAME = process.env.CLOUDINARY_CLOUD_NAME;
export const CLOUDINARY_API_KEY = process.env.CLOUDINARY_API_KEY;
export const CLOUDINARY_API_SECRET = process.env.CLOUDINARY_API_SECRET;

/**
 * ===========================================
 * MAILGUN EMAIL SERVICE
 * ===========================================
 */
export const MAILGUN_API_KEY = process.env.MAILGUN_API_KEY;
export const MAILGUN_DOMAIN = process.env.MAILGUN_DOMAIN;
export const MAILGUN_FROM_EMAIL = process.env.MAILGUN_FROM_EMAIL;

/**
# ===========================================
# LEADBUNKER SCRAPER API
# ===========================================
*/
export const SCRAPER_API_URL =
  process.env.SCRAPER_API_URL || 'http://localhost:8000';
export const SCRAPER_API_KEY = process.env.SCRAPER_API_KEY;
export const SCRAPER_WEBHOOK_SECRET = process.env.SCRAPER_WEBHOOK_SECRET;

/**
# ===========================================
# CRYPTOCURRENCY CONFIGURATION
# ===========================================
*/
// Set to 'testnet' for testing, 'mainnet' for production
export const CRYPTO_NETWORK = process.env.CRYPTO_NETWORK || 'mainnet';

export const MASTER_SEED = process.env.MASTER_SEED;

// RPC endpoints (free options provided)
export const ETH_RPC_URL = process.env.ETH_RPC_URL;
export const BTC_EXPLORER_URL = process.env.BTC_EXPLORER_URL;
export const TRON_GRID_URL = process.env.TRON_GRID_URL;

// API Keys
export const TRON_API_KEY = process.env.TRON_API_KEY;
export const ETHERSCAN_API_KEY = process.env.ETHERSCAN_API_KEY;

/**
 * CoinCap API Key (optional)
 * - Free tier: Unlimited reasonable usage
 * - With API key: Higher rate limits + advanced features
 * Get one at: https://coincap.io/api-key
 */
export const COINCAP_API_KEY = process.env.COINCAP_API_KEY;

// Treasury addresses
export const TREASURY_BTC_ADDRESS = process.env.TREASURY_BTC_ADDRESS;
export const TREASURY_ETH_ADDRESS = process.env.TREASURY_ETH_ADDRESS;
export const TREASURY_TRON_ADDRESS = process.env.TREASURY_TRON_ADDRESS;

// Encryption key for database
export const ENCRYPTION_KEY = process.env.ENCRYPTION_KEY;

/**
# ===========================================
# SENTRY ERROR TRACKING
# ===========================================
*/
export const NEXT_PUBLIC_SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN;
export const SENTRY_AUTH_TOKEN = process.env.SENTRY_AUTH_TOKEN;
export const SENTRY_ORG = process.env.SENTRY_ORG;
export const SENTRY_PROJECT = process.env.SENTRY_PROJECT;

/**
# ===========================================
# CREDIT SYSTEM CONFIGURATION
# ===========================================
*/
export const DEFAULT_FREE_CREDITS = process.env.DEFAULT_FREE_CREDITS || '100';
export const DEFAULT_TRIAL_DAYS = process.env.DEFAULT_TRIAL_DAYS || '7';
export const CREDIT_COST_DOMAIN_SCRAPE =
  process.env.CREDIT_COST_DOMAIN_SCRAPE || '1';
export const CREDIT_COST_EMAIL_VALIDATION =
  process.env.CREDIT_COST_EMAIL_VALIDATION || '0.1';
export const CREDIT_COST_PHONE_VALIDATION =
  process.env.CREDIT_COST_PHONE_VALIDATION || '0.2';
export const CREDIT_COST_SOCIAL_ENRICHMENT =
  process.env.CREDIT_COST_SOCIAL_ENRICHMENT || '0.5';
export const BUFFER_CREDITS = parseInt(process.env.BUFFER_CREDITS || '50', 10);
export const CREDIT_RATE = parseInt(process.env.CREDIT_RATE || '1000', 10);

/**
# ===========================================
# AUTHENTICATION CONFIGURATION
# ===========================================
*/
// Password hashing configuration
export const AUTH_SALT_ROUNDS = parseInt(
  process.env.AUTH_SALT_ROUNDS || '10',
  10,
);

// Token configuration
export const AUTH_TOKEN_LENGTH = parseInt(
  process.env.AUTH_TOKEN_LENGTH || '32',
  10,
);
export const AUTH_VERIFICATION_TOKEN_EXPIRY_HOURS = parseInt(
  process.env.AUTH_VERIFICATION_TOKEN_EXPIRY_HOURS || '24',
  10,
);
export const AUTH_PASSWORD_RESET_TOKEN_EXPIRY_HOURS = parseInt(
  process.env.AUTH_PASSWORD_RESET_TOKEN_EXPIRY_HOURS || '1',
  10,
);

// Token expiry in milliseconds (computed from hours)
export const AUTH_VERIFICATION_TOKEN_EXPIRY_MS =
  AUTH_VERIFICATION_TOKEN_EXPIRY_HOURS * 60 * 60 * 1000;
export const AUTH_PASSWORD_RESET_TOKEN_EXPIRY_MS =
  AUTH_PASSWORD_RESET_TOKEN_EXPIRY_HOURS * 60 * 60 * 1000;

// Welcome credits for new users (uses DEFAULT_FREE_CREDITS)
export const AUTH_WELCOME_CREDITS = parseInt(DEFAULT_FREE_CREDITS, 10);

/**
# ===========================================
# RATE LIMITING
# ===========================================
*/
export const API_RATE_LIMIT_PER_MINUTE =
  process.env.API_RATE_LIMIT_PER_MINUTE || '60';
export const API_RATE_LIMIT_PER_HOUR =
  process.env.API_RATE_LIMIT_PER_HOUR || '1000';

/**
# ===========================================
# FILE STORAGE
# ===========================================
*/
export const MAX_FILE_SIZE_MB = process.env.MAX_FILE_SIZE_MB || '50';
export const FILE_RETENTION_DAYS = process.env.FILE_RETENTION_DAYS || '30';

/**
# ===========================================
# ADMIN CONFIGURATION
# ===========================================
*/
export const ADMIN_EMAILS = process.env.ADMIN_EMAILS || 'admin@leabunker.io';

/**
# ===========================================
# WALLET DISPLAY CONFIGURATION
# ===========================================
*/
export * from './wallet-display';

/**
# ===========================================
# CRYPTO CONTRACT ADDRESSES CONFIGURATION
# ===========================================
*/

export const USDT_ERC20_CONTRACT = '0xdAC17F958D2ee523a2206206994597C13D831ec7';
export const USDT_TRC20_CONTRACT_MAINNET = 'TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t';
export const USDT_TRC20_CONTRACT_TESTNET = 'TG3XXyExBkPp9nzdajDZsozEu4BkaSJozs'; // Shasta testnet
export const USDC_ERC20_CONTRACT = '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48';

export const REQUIRED_CONFIRMATIONS: Record<string, number> = {
  BTC: 3,
  ETH: 12,
  USDT: 12,
  USDC: 12,
};
